import "./ErrorMsg.css"


export default function ErrMsg({ msg }) {
    return <>
        <i class="fa-sharp fa-solid fa-circle-exclamation" style={{ color: "#e84444", position: "absolute", top: "5px", right: "5px" }}></i>
        <span class="tooltiptext">{msg}</span>
    </>
}